class AmazonReportRemovalShipmentRequestParamsDto {
  /** 结束时间(yyyy-MM-dd HH:mm:ss) */
  endTime = "";

  /** 请求报告类型 */
  pushType = "";

  /** 开始时间(yyyy-MM-dd HH:mm:ss) */
  startTime = "";
}

class AmzFinancialEventModel {
  /** 亚马逊订单号 */
  amazonOrderId = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** 买家通过亚马逊提供的信用卡之一向亚马逊付款或买家通过货到付款直接向卖家付款的交易列表 */
  directPaymentList = "";

  /** id */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 市场:AU(AU)、EU(DE、ES、FR、IT、NL、PL、SE、TR、UK)、US(CA、MX、US)、JP(JP、SG) */
  market = "";

  /** 市场名称 */
  marketplaceName = "";

  /** 订单级费用调整列表。这些调整适用于多渠道配送 COD 订单 */
  orderChargeAdjustmentList = "";

  /** 订单级费用列表。这些费用适用于多渠道配送 COD 订单 */
  orderChargeList = "";

  /** 订单级费用调整列表。这些调整适用于多渠道配送订单 */
  orderFeeAdjustmentList = "";

  /** 订单级费用列表。这些费用适用于多渠道配送订单 */
  orderFeeList = "";

  /** 发布财务事件的日期和时间 */
  postedDate = "";

  /** 发运数量 */
  quantityShipped = undefined;

  /** 报告编号 */
  reportId = "";

  /** 请求编号 */
  requestId = "";

  /** 店铺SellerId */
  sellerId = "";

  /** 商户订单号 */
  sellerOrderId = "";

  /** sku */
  sellerSku = "";

  /** 货件级别费用调整列表 */
  shipmentFeeAdjustmentList = "";

  /** 货件级别费用列表 */
  shipmentFeeList = "";

  /** 货件调整列表 */
  shipmentItemAdjustmentList = "";

  /** 货件清单 */
  shipmentItemList = "";

  /** 站点店铺编号 */
  shopKey = "";

  /** 店铺名 */
  shopName = "";

  /** 店铺编号 */
  shopNo = "";

  /** shipment=装运,refund=退货,guaranteeClaim=保证索赔,chargeback=退款 */
  type = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class AmzFinancialEventQueryDto {
  /** 亚马逊订单号 */
  amazonOrderId = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** 买家通过亚马逊提供的信用卡之一向亚马逊付款或买家通过货到付款直接向卖家付款的交易列表 */
  directPaymentList = "";

  /** id */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 市场:AU(AU)、EU(DE、ES、FR、IT、NL、PL、SE、TR、UK)、US(CA、MX、US)、JP(JP、SG) */
  market = "";

  /** 市场名称 */
  marketplaceName = "";

  /** 订单级费用调整列表。这些调整适用于多渠道配送 COD 订单 */
  orderChargeAdjustmentList = "";

  /** 订单级费用列表。这些费用适用于多渠道配送 COD 订单 */
  orderChargeList = "";

  /** 订单级费用调整列表。这些调整适用于多渠道配送订单 */
  orderFeeAdjustmentList = "";

  /** 订单级费用列表。这些费用适用于多渠道配送订单 */
  orderFeeList = "";

  /** 发布财务事件的日期和时间 */
  postedDate = "";

  /** 发运数量 */
  quantityShipped = undefined;

  /** 报告编号 */
  reportId = "";

  /** 请求编号 */
  requestId = "";

  /** 店铺SellerId */
  sellerId = "";

  /** 商户订单号 */
  sellerOrderId = "";

  /** sku */
  sellerSku = "";

  /** 货件级别费用调整列表 */
  shipmentFeeAdjustmentList = "";

  /** 货件级别费用列表 */
  shipmentFeeList = "";

  /** 货件调整列表 */
  shipmentItemAdjustmentList = "";

  /** 货件清单 */
  shipmentItemList = "";

  /** 站点店铺编号 */
  shopKey = "";

  /** 店铺名 */
  shopName = "";

  /** 店铺编号 */
  shopNo = "";

  /** shipment=装运,refund=退货,guaranteeClaim=保证索赔,chargeback=退款 */
  type = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class AmzReportFulfillShipmentModel {
  /** 亚马逊订单号 */
  amazonOrderId = "";

  /** 亚马逊订单商品编号 */
  amazonOrderItemId = "";

  /** 单据地址1 */
  billAddress1 = "";

  /** 单据地址2 */
  billAddress2 = "";

  /** 单据地址3 */
  billAddress3 = "";

  /** 单据城市 */
  billCity = "";

  /** 单据国家 */
  billCountry = "";

  /** 单据邮政编码 */
  billPostalCode = "";

  /** 单据州 */
  billState = "";

  /** 买家邮箱 */
  buyerEmail = "";

  /** 买家姓名 */
  buyerName = "";

  /** 买家电话 */
  buyerPhoneNumber = "";

  /** 配送承运商 */
  carrier = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 购买币种 */
  currency = "";

  /** 删除标识 */
  deleted = undefined;

  /** 预计到达日期 */
  estimatedArrivalDate = "";

  /** 亚马逊运营中心 */
  fulfillmentCenterId = "";

  /** 配送方式(AFN:亚马逊;MFN:商户自配送) */
  fulfillmentChannel = "";

  /** 礼品包装总金额 */
  giftWrapPrice = "";

  /** 礼品包装税款 */
  giftWrapTax = "";

  /** id */
  id = undefined;

  /** 支付总金额 */
  itemPrice = "";

  /** 商品促销折扣 */
  itemPromotionDiscount = "";

  /** 总税款 */
  itemTax = "";

  /** 版本 */
  lockVersion = undefined;

  /** 市场:AU(AU)、EU(DE、ES、FR、IT、NL、PL、SE、TR、UK)、US(CA、MX、US)、JP(JP、SG) */
  market = "";

  /** 商户订单号 */
  merchantOrderId = "";

  /** 商户订单商品编号 */
  merchantOrderItemId = "";

  /** 付款完成日期 */
  paymentsDate = "";

  /** 产品名称 */
  productName = "";

  /** 下单日期 */
  purchaseDate = "";

  /** 配送数量 */
  quantityShipped = "";

  /** 收件人 */
  recipientName = "";

  /** 报告编号 */
  reportId = "";

  /** 报告日期 */
  reportingDate = "";

  /** 请求编号 */
  requestId = "";

  /** 订单来源 */
  salesChannel = "";

  /** 店铺SellerId */
  sellerId = "";

  /** 配送地址1 */
  shipAddress1 = "";

  /** 配送地址2 */
  shipAddress2 = "";

  /** 配送地址3 */
  shipAddress3 = "";

  /** 配送城市 */
  shipCity = "";

  /** 配送国家 */
  shipCountry = "";

  /** 配送电话 */
  shipPhoneNumber = "";

  /** 配送邮政编码 */
  shipPostalCode = "";

  /** 配送促销折扣 */
  shipPromotionDiscount = "";

  /** 配送服务类型 */
  shipServiceLevel = "";

  /** 配送州 */
  shipState = "";

  /** 配送完成日期 */
  shipmentDate = "";

  /** 货件编号 */
  shipmentId = "";

  /** 货件商品编号 */
  shipmentItemId = "";

  /** 配送总金额 */
  shippingPrice = "";

  /** 配送总税款 */
  shippingTax = "";

  /** 站点店铺编号 */
  shopKey = "";

  /** 店铺名 */
  shopName = "";

  /** 店铺编号 */
  shopNo = "";

  /** sku */
  sku = "";

  /** 包裹追踪编号 */
  trackingNumber = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class AmzReportFulfillShipmentQueryDto {
  /** 亚马逊订单号 */
  amazonOrderId = "";

  /** 亚马逊订单商品编号 */
  amazonOrderItemId = "";

  /** 单据地址1 */
  billAddress1 = "";

  /** 单据地址2 */
  billAddress2 = "";

  /** 单据地址3 */
  billAddress3 = "";

  /** 单据城市 */
  billCity = "";

  /** 单据国家 */
  billCountry = "";

  /** 单据邮政编码 */
  billPostalCode = "";

  /** 单据州 */
  billState = "";

  /** 买家邮箱 */
  buyerEmail = "";

  /** 买家姓名 */
  buyerName = "";

  /** 买家电话 */
  buyerPhoneNumber = "";

  /** 配送承运商 */
  carrier = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 购买币种 */
  currency = "";

  /** 删除标识 */
  deleted = undefined;

  /** 预计到达日期 */
  estimatedArrivalDate = "";

  /** 亚马逊运营中心 */
  fulfillmentCenterId = "";

  /** 配送方式(AFN:亚马逊;MFN:商户自配送) */
  fulfillmentChannel = "";

  /** 礼品包装总金额 */
  giftWrapPrice = "";

  /** 礼品包装税款 */
  giftWrapTax = "";

  /** id */
  id = undefined;

  /** 支付总金额 */
  itemPrice = "";

  /** 商品促销折扣 */
  itemPromotionDiscount = "";

  /** 总税款 */
  itemTax = "";

  /** 版本 */
  lockVersion = undefined;

  /** 市场:AU(AU)、EU(DE、ES、FR、IT、NL、PL、SE、TR、UK)、US(CA、MX、US)、JP(JP、SG) */
  market = "";

  /** 商户订单号 */
  merchantOrderId = "";

  /** 商户订单商品编号 */
  merchantOrderItemId = "";

  /** 付款完成日期 */
  paymentsDate = "";

  /** 产品名称 */
  productName = "";

  /** 下单日期 */
  purchaseDate = "";

  /** 配送数量 */
  quantityShipped = "";

  /** 收件人 */
  recipientName = "";

  /** 报告编号 */
  reportId = "";

  /** 报告日期 */
  reportingDate = "";

  /** 请求编号 */
  requestId = "";

  /** 订单来源 */
  salesChannel = "";

  /** 店铺SellerId */
  sellerId = "";

  /** 配送地址1 */
  shipAddress1 = "";

  /** 配送地址2 */
  shipAddress2 = "";

  /** 配送地址3 */
  shipAddress3 = "";

  /** 配送城市 */
  shipCity = "";

  /** 配送国家 */
  shipCountry = "";

  /** 配送电话 */
  shipPhoneNumber = "";

  /** 配送邮政编码 */
  shipPostalCode = "";

  /** 配送促销折扣 */
  shipPromotionDiscount = "";

  /** 配送服务类型 */
  shipServiceLevel = "";

  /** 配送州 */
  shipState = "";

  /** 配送完成日期 */
  shipmentDate = "";

  /** 货件编号 */
  shipmentId = "";

  /** 货件商品编号 */
  shipmentItemId = "";

  /** 配送总金额 */
  shippingPrice = "";

  /** 配送总税款 */
  shippingTax = "";

  /** 站点店铺编号 */
  shopKey = "";

  /** 店铺名 */
  shopName = "";

  /** 店铺编号 */
  shopNo = "";

  /** sku */
  sku = "";

  /** 包裹追踪编号 */
  trackingNumber = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class AmzReportInventoryMonthlyModel {
  /** 每日平均可供货数量 */
  averageQuantity = "";

  /** 国家 */
  country = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** 库存属性 */
  detailedDisposition = "";

  /** 月末剩余数量 */
  endQuantity = "";

  /** fnsku */
  fnsku = "";

  /** 亚马逊运营中心 */
  fulfillmentCenterId = "";

  /** id */
  id = undefined;

  /** 在途和月末的和 */
  inTransitAndEndingSum = "";

  /** 在途数量 */
  inTransitBetweenWarehouses = "";

  /** 国家 */
  location = "";

  /** 版本 */
  lockVersion = undefined;

  /** 市场:AU(AU)、EU(DE、ES、FR、IT、NL、PL、SE、TR、UK)、US(CA、MX、US)、JP(JP、SG) */
  market = "";

  /** 月份 */
  month = "";

  /** 产品名称 */
  productName = "";

  /** 报告编号 */
  reportId = "";

  /** 请求编号 */
  requestId = "";

  /** 店铺SellerId */
  sellerId = "";

  /** 站点店铺编号 */
  shopKey = "";

  /** 店铺名 */
  shopName = "";

  /** 店铺编号 */
  shopNo = "";

  /** sku */
  sku = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class AmzReportInventoryMonthlyQueryDto {
  /** 每日平均可供货数量 */
  averageQuantity = "";

  /** 国家 */
  country = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** 库存属性 */
  detailedDisposition = "";

  /** 月末剩余数量 */
  endQuantity = "";

  /** fnsku */
  fnsku = "";

  /** 亚马逊运营中心 */
  fulfillmentCenterId = "";

  /** id */
  id = undefined;

  /** 在途和月末的和 */
  inTransitAndEndingSum = "";

  /** 在途数量 */
  inTransitBetweenWarehouses = "";

  /** 国家 */
  location = "";

  /** 版本 */
  lockVersion = undefined;

  /** 市场:AU(AU)、EU(DE、ES、FR、IT、NL、PL、SE、TR、UK)、US(CA、MX、US)、JP(JP、SG) */
  market = "";

  /** 月份 */
  month = "";

  /** 产品名称 */
  productName = "";

  /** 报告编号 */
  reportId = "";

  /** 请求编号 */
  requestId = "";

  /** 店铺SellerId */
  sellerId = "";

  /** 站点店铺编号 */
  shopKey = "";

  /** 店铺名 */
  shopName = "";

  /** 店铺编号 */
  shopNo = "";

  /** sku */
  sku = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class AmzReportInventoryReceiptModel {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** 货件编码 */
  fbaShipmentId = "";

  /** fnsku */
  fnsku = "";

  /** 亚马逊运营中心 */
  fulfillmentCenterId = "";

  /** id */
  id = undefined;

  /** 国家 */
  location = "";

  /** 版本 */
  lockVersion = undefined;

  /** 市场:AU(AU)、EU(DE、ES、FR、IT、NL、PL、SE、TR、UK)、US(CA、MX、US)、JP(JP、SG) */
  market = "";

  /** 产品名称 */
  productName = "";

  /** 数量 */
  quantity = "";

  /** 接收日期 */
  receivedDate = "";

  /** 报告编号 */
  reportId = "";

  /** 请求编号 */
  requestId = "";

  /** 店铺SellerId */
  sellerId = "";

  /** 站点店铺编号 */
  shopKey = "";

  /** 店铺名 */
  shopName = "";

  /** 店铺编号 */
  shopNo = "";

  /** sku */
  sku = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class AmzReportInventoryReceiptQueryDto {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** 货件编码 */
  fbaShipmentId = "";

  /** fnsku */
  fnsku = "";

  /** 亚马逊运营中心 */
  fulfillmentCenterId = "";

  /** id */
  id = undefined;

  /** 国家 */
  location = "";

  /** 版本 */
  lockVersion = undefined;

  /** 市场:AU(AU)、EU(DE、ES、FR、IT、NL、PL、SE、TR、UK)、US(CA、MX、US)、JP(JP、SG) */
  market = "";

  /** 产品名称 */
  productName = "";

  /** 数量 */
  quantity = "";

  /** 接收日期 */
  receivedDate = "";

  /** 报告编号 */
  reportId = "";

  /** 请求编号 */
  requestId = "";

  /** 店铺SellerId */
  sellerId = "";

  /** 站点店铺编号 */
  shopKey = "";

  /** 店铺名 */
  shopName = "";

  /** 店铺编号 */
  shopNo = "";

  /** sku */
  sku = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class AmzReportInventorySummaryModel {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** 库存属性 */
  disposition = "";

  /** fnsku */
  fnsku = "";

  /** 亚马逊运营中心 */
  fulfillmentCenterId = "";

  /** id */
  id = undefined;

  /** 国家 */
  location = "";

  /** 版本 */
  lockVersion = undefined;

  /** 市场:AU(AU)、EU(DE、ES、FR、IT、NL、PL、SE、TR、UK)、US(CA、MX、US)、JP(JP、SG) */
  market = "";

  /** 产品名称 */
  productName = "";

  /** 数量 */
  quantity = "";

  /** 报告编号 */
  reportId = "";

  /** 请求编号 */
  requestId = "";

  /** 店铺SellerId */
  sellerId = "";

  /** 站点店铺编号 */
  shopKey = "";

  /** 店铺名 */
  shopName = "";

  /** 店铺编号 */
  shopNo = "";

  /** sku */
  sku = "";

  /** 请求日期 */
  snapshotDate = "";

  /** 交易类型 */
  transactionType = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class AmzReportInventorySummaryQueryDto {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** 库存属性 */
  disposition = "";

  /** fnsku */
  fnsku = "";

  /** 亚马逊运营中心 */
  fulfillmentCenterId = "";

  /** id */
  id = undefined;

  /** 国家 */
  location = "";

  /** 版本 */
  lockVersion = undefined;

  /** 市场:AU(AU)、EU(DE、ES、FR、IT、NL、PL、SE、TR、UK)、US(CA、MX、US)、JP(JP、SG) */
  market = "";

  /** 产品名称 */
  productName = "";

  /** 数量 */
  quantity = "";

  /** 报告编号 */
  reportId = "";

  /** 请求编号 */
  requestId = "";

  /** 店铺SellerId */
  sellerId = "";

  /** 站点店铺编号 */
  shopKey = "";

  /** 店铺名 */
  shopName = "";

  /** 店铺编号 */
  shopNo = "";

  /** sku */
  sku = "";

  /** 请求日期 */
  snapshotDate = "";

  /** 交易类型 */
  transactionType = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class AmzReportRemovalShipmentModel {
  /** 配送承运商 */
  carrier = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** 库存属性 */
  disposition = "";

  /** fnsku */
  fnsku = "";

  /** id */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 市场:AU(AU)、EU(DE、ES、FR、IT、NL、PL、SE、TR、UK)、US(CA、MX、US)、JP(JP、SG) */
  market = "";

  /** 订单编号 */
  orderId = "";

  /** 移除订单类型 */
  removalOrderType = "";

  /** 报告编号 */
  reportId = "";

  /** 请求日期 */
  requestDate = "";

  /** 请求编号 */
  requestId = "";

  /** 店铺SellerId */
  sellerId = "";

  /** 完成配送日期 */
  shipmentDate = "";

  /** 完成配送日期 */
  shipmentDateTime = "";

  /** 本次退货中已配送的数量 */
  shippedQuantity = "";

  /** 站点店铺编号 */
  shopKey = "";

  /** 店铺名 */
  shopName = "";

  /** 店铺编号 */
  shopNo = "";

  /** sku */
  sku = "";

  /** 包裹追踪编号 */
  trackingNumber = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class AmzReportRemovalShipmentQueryDto {
  /** 配送承运商 */
  carrier = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** 库存属性 */
  disposition = "";

  /** fnsku */
  fnsku = "";

  /** id */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 市场:AU(AU)、EU(DE、ES、FR、IT、NL、PL、SE、TR、UK)、US(CA、MX、US)、JP(JP、SG) */
  market = "";

  /** 订单编号 */
  orderId = "";

  /** 移除订单类型 */
  removalOrderType = "";

  /** 报告编号 */
  reportId = "";

  /** 请求日期 */
  requestDate = "";

  /** 请求编号 */
  requestId = "";

  /** 店铺SellerId */
  sellerId = "";

  /** 完成配送日期 */
  shipmentDate = "";

  /** 完成配送日期 */
  shipmentDateTime = "";

  /** 完成配送日期结束 */
  shipmentDateTimeEnd = "";

  /** 完成配送日期开始 */
  shipmentDateTimeStart = "";

  /** 本次退货中已配送的数量 */
  shippedQuantity = "";

  /** 站点店铺编号 */
  shopKey = "";

  /** 店铺名 */
  shopName = "";

  /** 店铺编号 */
  shopNo = "";

  /** sku */
  sku = "";

  /** 包裹追踪编号 */
  trackingNumber = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class AmzReportRequestNoticeDetailResponseDto {
  /** 处理结果 */
  callbackStatus = "";

  /** 文件地址 */
  fileUrl = "";

  /** oss_bucket_name */
  ossBucketName = "";

  /** oss_path */
  ossPath = "";

  /** 报表内容类型和编码 */
  reportContentType = "";

  /** 亚马逊报告id(报告类的都有,财务报告/入库货件报告的用requestId填充) */
  reportId = "";
}

class AmzReportRequestNoticeResponseDto {
  /** 响应详情 */
  detail = [];

  /** 结果总数 */
  fileCount = undefined;

  /** 请求编号 */
  requestId = "";

  /** 请求报告类型 */
  requestType = "";
}

class AmzReportRequestRecordModel {
  /** 业务时间 */
  businessTime = "";

  /** 是否完成 */
  completeFlag = false;

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 拉取到的条目数 */
  dataCount = undefined;

  /** 删除标识 */
  deleted = undefined;

  /** 查询结束时间 */
  endTime = "";

  /** id */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 市场:AU(AU)、EU(DE、ES、FR、IT、NL、PL、SE、TR、UK)、US(CA、MX、US)、JP(JP、SG) */
  market = "";

  /** 请求编号 */
  requestId = "";

  /** 请求时间 */
  requestTime = "";

  /** 请求报告类型 */
  requestType = "";

  /** 请求报告类型名称 */
  requestTypeName = "";

  /** 响应时间 */
  responseTime = "";

  /** 重试标识 */
  retryFlag = false;

  /** 最早重试时间 */
  retryTime = "";

  /** 店铺SellerId */
  sellerId = "";

  /** 站点店铺编号 */
  shopKey = "";

  /** 店铺名 */
  shopName = "";

  /** 店铺编号 */
  shopNo = "";

  /** 查询开始时间 */
  startTime = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class AmzReportRequestRecordQueryDto {
  /** 业务时间 */
  businessTime = "";

  /** 是否完成 */
  completeFlag = false;

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 拉取到的条目数 */
  dataCount = undefined;

  /** 查询结束时间 */
  endTime = "";

  /** id */
  id = undefined;

  /** 市场:AU(AU)、EU(DE、ES、FR、IT、NL、PL、SE、TR、UK)、US(CA、MX、US)、JP(JP、SG) */
  market = "";

  /** 请求编号 */
  requestId = "";

  /** 请求时间 */
  requestTime = "";

  /** 请求报告类型 */
  requestType = "";

  /** 请求报告类型名称 */
  requestTypeName = "";

  /** 响应时间 */
  responseTime = "";

  /** 重试标识 */
  retryFlag = false;

  /** 最早重试时间 */
  retryTime = "";

  /** 店铺SellerId */
  sellerId = "";

  /** 站点店铺编号 */
  shopKey = "";

  /** 店铺名 */
  shopName = "";

  /** 店铺编号 */
  shopNo = "";

  /** 查询开始时间 */
  startTime = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class AmzReportRequestResultModel {
  /** 亚马逊处理状态 */
  callbackStatus = "";

  /** 文档类型：默认text/plain */
  contentType = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 拉取到的条目数 */
  dataCount = undefined;

  /** 删除标识 */
  deleted = undefined;

  /** 文件地址 */
  fileUrl = "";

  /** 是否解析 */
  handleFlag = false;

  /** id */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 市场:AU(AU)、EU(DE、ES、FR、IT、NL、PL、SE、TR、UK)、US(CA、MX、US)、JP(JP、SG) */
  market = "";

  /** oss_bucket_name */
  ossBucketName = "";

  /** oss_path */
  ossPath = "";

  /** 报告编号 */
  reportId = "";

  /** 请求编号 */
  requestId = "";

  /** 店铺SellerId */
  sellerId = "";

  /** 站点店铺编号 */
  shopKey = "";

  /** 店铺名 */
  shopName = "";

  /** 店铺编号 */
  shopNo = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class AmzReportRequestResultQueryDto {
  /** 亚马逊处理状态 */
  callbackStatus = "";

  /** 文档类型：默认text/plain */
  contentType = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 拉取到的条目数 */
  dataCount = undefined;

  /** 文件地址 */
  fileUrl = "";

  /** 是否解析 */
  handleFlag = false;

  /** id */
  id = undefined;

  /** 市场:AU(AU)、EU(DE、ES、FR、IT、NL、PL、SE、TR、UK)、US(CA、MX、US)、JP(JP、SG) */
  market = "";

  /** oss_bucket_name */
  ossBucketName = "";

  /** oss_path */
  ossPath = "";

  /** 报告编号 */
  reportId = "";

  /** 请求编号 */
  requestId = "";

  /** 店铺SellerId */
  sellerId = "";

  /** 站点店铺编号 */
  shopKey = "";

  /** 店铺名 */
  shopName = "";

  /** 店铺编号 */
  shopNo = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class AmzReportReturnModel {
  /** asin */
  asin = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 买家补充的退货原因详情 */
  customerComments = "";

  /** 删除标识 */
  deleted = undefined;

  /** 商品状态 */
  detailedDisposition = "";

  /** fnsku */
  fnsku = "";

  /** 亚马逊运营中心 */
  fulfillmentCenterId = "";

  /** id */
  id = undefined;

  /** 识别商品的唯一配送序列号 */
  licensePlateNumber = "";

  /** 版本 */
  lockVersion = undefined;

  /** 市场:AU(AU)、EU(DE、ES、FR、IT、NL、PL、SE、TR、UK)、US(CA、MX、US)、JP(JP、SG) */
  market = "";

  /** 订单编号 */
  orderId = "";

  /** 产品名称 */
  productName = "";

  /** 数量 */
  quantity = "";

  /** 退货原因 */
  reason = "";

  /** 报告编号 */
  reportId = "";

  /** 请求编号 */
  requestId = "";

  /** 退货日期 */
  returnDate = "";

  /** 店铺SellerId */
  sellerId = "";

  /** 站点店铺编号 */
  shopKey = "";

  /** 店铺名 */
  shopName = "";

  /** 店铺编号 */
  shopNo = "";

  /** sku */
  sku = "";

  /** 退货状态 */
  status = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class AmzReportReturnQueryDto {
  /** asin */
  asin = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 买家补充的退货原因详情 */
  customerComments = "";

  /** 删除标识 */
  deleted = undefined;

  /** 商品状态 */
  detailedDisposition = "";

  /** fnsku */
  fnsku = "";

  /** 亚马逊运营中心 */
  fulfillmentCenterId = "";

  /** id */
  id = undefined;

  /** 识别商品的唯一配送序列号 */
  licensePlateNumber = "";

  /** 版本 */
  lockVersion = undefined;

  /** 市场:AU(AU)、EU(DE、ES、FR、IT、NL、PL、SE、TR、UK)、US(CA、MX、US)、JP(JP、SG) */
  market = "";

  /** 订单编号 */
  orderId = "";

  /** 产品名称 */
  productName = "";

  /** 数量 */
  quantity = "";

  /** 退货原因 */
  reason = "";

  /** 报告编号 */
  reportId = "";

  /** 请求编号 */
  requestId = "";

  /** 退货日期 */
  returnDate = "";

  /** 店铺SellerId */
  sellerId = "";

  /** 站点店铺编号 */
  shopKey = "";

  /** 店铺名 */
  shopName = "";

  /** 店铺编号 */
  shopNo = "";

  /** sku */
  sku = "";

  /** 退货状态 */
  status = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class AmzReportSettlementModel {
  /** 调整id */
  adjustmentId = "";

  /** 金额 */
  amount = "";

  /** 金额说明 */
  amountDescription = "";

  /** 金额类型 */
  amountType = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 币种 */
  currency = "";

  /** 删除标识 */
  deleted = undefined;

  /** 存款日期 */
  depositDate = "";

  /** 履行id */
  fulfillmentId = "";

  /** 是否表头 */
  headFlag = false;

  /** id */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 市场:AU(AU)、EU(DE、ES、FR、IT、NL、PL、SE、TR、UK)、US(CA、MX、US)、JP(JP、SG) */
  market = "";

  /** 市场名称 */
  marketplaceName = "";

  /** 商户调整项id */
  merchantAdjustmentItemId = "";

  /** 商户订单id */
  merchantOrderId = "";

  /** 商户订单项id */
  merchantOrderItemId = "";

  /** 订单id */
  orderId = "";

  /** 订单货件编码 */
  orderItemCode = "";

  /** 发布日期 */
  postedDate = "";

  /** 发布时间 */
  postedDateTime = "";

  /** 促销id */
  promotionId = "";

  /** 购买数量 */
  quantityPurchased = "";

  /** 报告编号 */
  reportId = "";

  /** 请求编号 */
  requestId = "";

  /** 店铺SellerId */
  sellerId = "";

  /** 结算结束时间 */
  settlementEndDate = "";

  /** 结算id */
  settlementId = "";

  /** 结算开始时间 */
  settlementStartDate = "";

  /** 货件编号 */
  shipmentId = "";

  /** 站点店铺编号 */
  shopKey = "";

  /** 店铺名 */
  shopName = "";

  /** 店铺编号 */
  shopNo = "";

  /** sku */
  sku = "";

  /** 总金额 */
  totalAmount = "";

  /** 交易类型 */
  transactionType = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class AmzReportSettlementQueryDto {
  /** 调整id */
  adjustmentId = "";

  /** 金额 */
  amount = "";

  /** 金额说明 */
  amountDescription = "";

  /** 金额类型 */
  amountType = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 币种 */
  currency = "";

  /** 删除标识 */
  deleted = undefined;

  /** 存款日期 */
  depositDate = "";

  /** 履行id */
  fulfillmentId = "";

  /** 是否表头 */
  headFlag = false;

  /** id */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** 市场:AU(AU)、EU(DE、ES、FR、IT、NL、PL、SE、TR、UK)、US(CA、MX、US)、JP(JP、SG) */
  market = "";

  /** 市场名称 */
  marketplaceName = "";

  /** 商户调整项id */
  merchantAdjustmentItemId = "";

  /** 商户订单id */
  merchantOrderId = "";

  /** 商户订单项id */
  merchantOrderItemId = "";

  /** 订单id */
  orderId = "";

  /** 订单货件编码 */
  orderItemCode = "";

  /** 发布日期 */
  postedDate = "";

  /** 发布时间 */
  postedDateTime = "";

  /** 促销id */
  promotionId = "";

  /** 购买数量 */
  quantityPurchased = "";

  /** 报告编号 */
  reportId = "";

  /** 请求编号 */
  requestId = "";

  /** 店铺SellerId */
  sellerId = "";

  /** 结算结束时间 */
  settlementEndDate = "";

  /** 结算结束时间 */
  settlementEndDates = [];

  /** 结算id */
  settlementId = "";

  /** 结算开始时间 */
  settlementStartDate = "";

  /** 货件编号 */
  shipmentId = "";

  /** 站点店铺编号 */
  shopKey = "";

  /** 店铺名 */
  shopName = "";

  /** 店铺编号 */
  shopNo = "";

  /** sku */
  sku = "";

  /** 总金额 */
  totalAmount = "";

  /** 交易类型 */
  transactionType = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class AmzonReportSettlementPageDto {
  /** 批号 */
  bactchNumber = "";

  /** 请求页码 */
  page = undefined;

  /** 请求页码 */
  pageSize = undefined;

  /** 报告编号 */
  reportId = "";
}

class IPage {
  /** current */
  current = undefined;

  /** hitCount */
  hitCount = false;

  /** pages */
  pages = undefined;

  /** records */
  records = [];

  /** searchCount */
  searchCount = false;

  /** size */
  size = undefined;

  /** total */
  total = undefined;
}

class MonthlyReportModelObject {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 */
  deleted = undefined;

  /** 生产失败信息 */
  failInfo = "";

  /** id */
  id = undefined;

  /** 版本 */
  lockVersion = undefined;

  /** oss保存路径 */
  ossPath = "";

  /** 报告月份 */
  reportMonth = "";

  /** 报告名称 */
  reportName = "";

  /** 生成状态 */
  reportStatus = "";

  /** 报告类型 */
  reportType = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";
}

class PageInfo {
  /** endRow */
  endRow = undefined;

  /** hasNextPage */
  hasNextPage = false;

  /** hasPreviousPage */
  hasPreviousPage = false;

  /** isFirstPage */
  isFirstPage = false;

  /** isLastPage */
  isLastPage = false;

  /** list */
  list = [];

  /** navigateFirstPage */
  navigateFirstPage = undefined;

  /** navigateLastPage */
  navigateLastPage = undefined;

  /** navigatePages */
  navigatePages = undefined;

  /** navigatepageNums */
  navigatepageNums = [];

  /** nextPage */
  nextPage = undefined;

  /** pageNum */
  pageNum = undefined;

  /** pageSize */
  pageSize = undefined;

  /** pages */
  pages = undefined;

  /** prePage */
  prePage = undefined;

  /** size */
  size = undefined;

  /** startRow */
  startRow = undefined;

  /** total */
  total = undefined;
}

class PauseShopRequestParamsDtoObject {
  /** 亚马逊seller_id */
  sellerId = "";

  /** 中台店铺标识 */
  shopKey = "";

  /** 是否调拨销售 */
  status = false;
}

class PauseShopResponseDtoObject {
  /** 亚马逊seller_id */
  sellerId = "";

  /** 中台店铺标识 */
  shopKey = "";

  /** 是否调拨销售 */
  status = false;
}

class PlatformReportRequestDto {
  /** 报告有效期结束 */
  endTime = "";

  /** 平台 */
  platform = "";

  /** 推送异常原因 */
  pushErrorMessage = "";

  /** 推送状态 1：已推送，0：未推送，2：推送异常 */
  pushStatus = undefined;

  /** 报告编号 */
  reportParentNo = "";

  /** 报告路径 */
  reportPath = [];

  /** 报告类型(报告名称) */
  reportType = "";

  /** 报告类型(报告英文名称) */
  reportTypeCode = "";

  /** 店铺编码code */
  shopCode = "";

  /** 店铺 */
  shopName = "";

  /** 报告有效期开始 */
  startTime = "";
}

class PlatformReportResponseDto {
  /** 创建时间 */
  createTime = "";

  /** 报告有效期结束 */
  endTime = "";

  /** 平台 */
  platform = "";

  /** 推送状态 1：已推送，0：未推送，2：推送异常 */
  pushStatus = undefined;

  /** 报告推送时间 */
  pushTime = "";

  /** 报告父编号 */
  reportParentNo = "";

  /** 报告类型 */
  reportType = "";

  /** 店铺编码code */
  shopCode = "";

  /** 店铺 */
  shopName = "";

  /** 站点 */
  site = "";

  /** 报告有效期开始 */
  startTime = "";

  /** 更新时间 */
  updateTime = "";
}

class PushReportRequestDto {
  /** 推送目的(库存中心，结算中心等) */
  pushDate = "";

  /** 推送异常原因 */
  pushErrorMessage = "";

  /** 推送状态 1：已推送，0：未推送，2：推送异常 */
  pushStatus = undefined;

  /** 报告编号 */
  reportParentNo = "";
}

class ReportResponseDtoObject {
  /** 报告类型 */
  createReportTypeEnum = "FINANCIAL_EVENT";

  /** 结束时间 */
  endTime = "";

  /** 店铺sellerId */
  sellerId = "";

  /** 开始时间 */
  starTime = "";
}

class Response {
  /** code */
  code = "";

  /** failed */
  failed = false;

  /** msg */
  msg = "";

  /** success */
  success = false;

  /** traceId */
  traceId = "";
}

class ResponseDto {
  /** code */
  code = "";

  /** data */
  data = new IPage();

  /** failed */
  failed = false;

  /** msg */
  msg = "";

  /** success */
  success = false;

  /** traceId */
  traceId = "";
}

class WfsReportRealTimeInventoryModel {
  /** 365+天 */
  ats365PlusDays = "";

  /** 90天 */
  atsNinetyDays = "";

  /** 180天 */
  atsOneHundredAndEightyDays = "";

  /** 365天 */
  atsThreeHundredAndSixtyFiveDays = "";

  /** 270天 */
  atsTwoHundredDndSeventyDays = "";

  /** 可出售单位 */
  availableToSellUnits = "";

  /** 品牌 */
  brandName = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 使用多维数据集 */
  cubeUsed = "";

  /** 损坏的收据 */
  damageReceipts = "";

  /** 过去30天的销售额计算的供应天数 */
  daysOfSupplyBasedOnLast30DaysSales = "";

  /** 删除标识 */
  deleted = undefined;

  /** 首次入库日期 */
  firstInStockDate = "";

  /** 条形码 */
  gtin = "";

  /** id */
  id = undefined;

  /** 入库单位 */
  inboundUnits = "";

  /** 商品id */
  itemId = "";

  /** 前30天库存 */
  last30DaysInstockDays = "";

  /** 最近30天po单位 */
  last30DaysPoUnits = "";

  /** 最近30天的销售额 */
  last30DaysSales = "";

  /** 最近30天收到的单位 */
  last30DaysUnitsReceived = "";

  /** 最近30天单位销售额 */
  last30DaysUnitsSales = "";

  /** 前7天库存 */
  last7DaysInstockDays = "";

  /** 最近7天的销售额 */
  last7DaysSales = "";

  /** 最近7天单位销售额 */
  last7DaysUnitsSales = "";

  /** 版本 */
  lockVersion = undefined;

  /** 市场:AU(AU)、EU(DE、ES、FR、IT、NL、PL、SE、TR、UK)、US(CA、MX、US)、JP(JP、SG) */
  market = "";

  /** 预计缺货日期 */
  predictedOutOfStockDate = "";

  /** 商品名称 */
  productName = "";

  /** 出版 */
  published = "";

  /** 建议补货数量 */
  recommendedReplenishmentQuantityBasedOnLast30DaysSales = "";

  /** 报告编号 */
  reportId = "";

  /** 请求日期 */
  requestDate = "";

  /** 请求编号 */
  requestId = "";

  /** 站点店铺编号 */
  shopKey = "";

  /** 店铺名 */
  shopName = "";

  /** 店铺编号 */
  shopNo = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";

  /** 供应商sku */
  vendorSku = "";
}

class WfsReportRealTimeInventoryQueryDto {
  /** 365+天 */
  ats365PlusDays = "";

  /** 90天 */
  atsNinetyDays = "";

  /** 180天 */
  atsOneHundredAndEightyDays = "";

  /** 365天 */
  atsThreeHundredAndSixtyFiveDays = "";

  /** 270天 */
  atsTwoHundredDndSeventyDays = "";

  /** 可出售单位 */
  availableToSellUnits = "";

  /** 品牌 */
  brandName = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 使用多维数据集 */
  cubeUsed = "";

  /** 损坏的收据 */
  damageReceipts = "";

  /** 过去30天的销售额计算的供应天数 */
  daysOfSupplyBasedOnLast30DaysSales = "";

  /** 首次入库日期 */
  firstInStockDate = "";

  /** 条形码 */
  gtin = "";

  /** id */
  id = undefined;

  /** 入库单位 */
  inboundUnits = "";

  /** 商品id */
  itemId = "";

  /** 前30天库存 */
  last30DaysInstockDays = "";

  /** 最近30天po单位 */
  last30DaysPoUnits = "";

  /** 最近30天的销售额 */
  last30DaysSales = "";

  /** 最近30天收到的单位 */
  last30DaysUnitsReceived = "";

  /** 最近30天单位销售额 */
  last30DaysUnitsSales = "";

  /** 前7天库存 */
  last7DaysInstockDays = "";

  /** 最近7天的销售额 */
  last7DaysSales = "";

  /** 最近7天单位销售额 */
  last7DaysUnitsSales = "";

  /** 市场:AU(AU)、EU(DE、ES、FR、IT、NL、PL、SE、TR、UK)、US(CA、MX、US)、JP(JP、SG) */
  market = "";

  /** 预计缺货日期 */
  predictedOutOfStockDate = "";

  /** 商品名称 */
  productName = "";

  /** 出版 */
  published = "";

  /** 建议补货数量 */
  recommendedReplenishmentQuantityBasedOnLast30DaysSales = "";

  /** 报告编号 */
  reportId = "";

  /** 请求日期 */
  requestDate = "";

  /** 请求编号 */
  requestId = "";

  /** 站点店铺编号 */
  shopKey = "";

  /** 店铺名 */
  shopName = "";

  /** 店铺编号 */
  shopNo = "";

  /** 修改人 */
  updateBy = "";

  /** 修改时间 */
  updateTime = "";

  /** 供应商sku */
  vendorSku = "";
}

export const platDataFlow = {
  AmazonReportRemovalShipmentRequestParamsDto,
  AmzFinancialEventModel,
  AmzFinancialEventQueryDto,
  AmzReportFulfillShipmentModel,
  AmzReportFulfillShipmentQueryDto,
  AmzReportInventoryMonthlyModel,
  AmzReportInventoryMonthlyQueryDto,
  AmzReportInventoryReceiptModel,
  AmzReportInventoryReceiptQueryDto,
  AmzReportInventorySummaryModel,
  AmzReportInventorySummaryQueryDto,
  AmzReportRemovalShipmentModel,
  AmzReportRemovalShipmentQueryDto,
  AmzReportRequestNoticeDetailResponseDto,
  AmzReportRequestNoticeResponseDto,
  AmzReportRequestRecordModel,
  AmzReportRequestRecordQueryDto,
  AmzReportRequestResultModel,
  AmzReportRequestResultQueryDto,
  AmzReportReturnModel,
  AmzReportReturnQueryDto,
  AmzReportSettlementModel,
  AmzReportSettlementQueryDto,
  AmzonReportSettlementPageDto,
  IPage,
  MonthlyReportModelObject,
  PageInfo,
  PauseShopRequestParamsDtoObject,
  PauseShopResponseDtoObject,
  PlatformReportRequestDto,
  PlatformReportResponseDto,
  PushReportRequestDto,
  ReportResponseDtoObject,
  Response,
  ResponseDto,
  WfsReportRealTimeInventoryModel,
  WfsReportRealTimeInventoryQueryDto,
};
